// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"e81d30ff807df321","5763":"53279b119a80342a","6893":"b11967d33a5c20e1","6974":"7a87319d07af7f1d","7222":"5506c356bb62e9f0","7937":"fc2e7ba3391b7527"}[chunkId] + ".js";
};